import {
    call,
    put,
    select,
    takeLatest,
    takeEvery,
    all,
    delay
  } from 'redux-saga/effects';
import api from '../../util/api';
import helper from '../../util/helper';
import history from '../../util/history';
// import * as RootNavigation from '../../../RootNavigation';
import { getPelaporanFail, getPelaporanSuccess, getTransferDetailFail, getTransferDetailSuccess, submitPelaporanFail, submitPelaporanSuccess } from './actions';

  import * as constants from './constants';
  
  import makeSelectWasteTransferFormScreen from './selector';
  
  export function* doSubmitPelaporan(action) {
    const {id_branch, origin_screen} = action;
    const dataset = yield select(makeSelectWasteTransferFormScreen());
    try {
      const params = {
          id_pelaporan: dataset.id_pelaporan,
          id_ruang: dataset.id_item,
          id_inventaris: dataset.id_aset,
          description: dataset.description,
          notes: dataset.notes,
          attachment: dataset.assets,
      };

      // console.log(params);

      const response = yield call(api.pelaporan.submitPelaporan, params);
      yield put(
        submitPelaporanSuccess(response.data, dataset.id_aset),
      );
      helper.successToast("Data berhasil disimpan");
      console.log("res:", response.data);

      // save current pelaporan
      if(origin_screen == 'pelaporan-detail'){
        api.saveCurrInputPelaporan(dataset.id_aset, response.data.id_pelaporan);
        history.push(origin_screen, {id_branch: id_branch, id_item: dataset.id_item, new_data: false});
      }else{
        history.push(origin_screen);
      }
      
  
    } catch (err) {
      console.log(err);
      helper.errorToast("Gagal Menyimpan data, silahkan hub admin");
      yield put(submitPelaporanFail(err));
    }
  }

  export function* doGetTransferDetail(action) {
    const dataset = yield select(makeSelectWasteTransferFormScreen());

    const params = {
      id_transfer: action.id_transfer,
      id_approval: action.id_approval,
      jns_approval_code: action.approval_code,
    }

    try {
      const response = yield call(api.unit.getTransferDetail, params);
      const {success} = response.data;
      // const {success} = JSON.parse('{"success":{"dtTrfLimbah":[],"dtApproval":{"id":63,"id_pegawai_kasie":1,"id_vendor":null,"id_unit_tujuan":1,"id_unit_tps":3,"code":"APV/20240905/3/1725523355","tgl_penugasan":"2024-09-02 06:00:00+07","noted":null,"status":"10","action":"I","date_action":"2024-09-05 15:02:35.868405+07","ms_unit_tujuan":{"id":1,"code":"01","nama":"UNIT 01","status":true,"action":"U","date_action":"2024-08-22 09:39:35.508755+07"},"ms_unit_t_p_s":{"id":3,"code":"03","nama":"UNIT 03","status":true,"action":"U","date_action":"2024-08-20 15:17:12.007957+07"},"ms_vendor":null,"approval_ba":{"id":50,"id_approval":63,"id_manifest":null,"id_unit_tujuan":1,"id_unit_tps":3,"code_ba":"BA/20240905/3/1725523355                                                                                                                                                                                                                                                                                    ","tgl_cetak":"2024-09-05 15:02:35.868405+07","status":"10","action":"I","date_action":"2024-09-05 15:02:35.868405+07"},"approvalkasie_detail":[{"id":83,"id_approval":63,"id_approval_request":38,"noted":null,"status":"10","action":"I","date_action":"2024-09-05 15:02:35.868405+07","approval_request":{"id":38,"id_unit":1,"id_rujukan_header":44,"id_rujukan_detail":42,"tipe_rujukan":"1","status":"10","date_create":"2024-08-23 14:25:08.734614+07","action":"U","date_action":"2024-09-05 14:13:53.99245+07","id_user":1,"id_jenis_limbah":1,"code_limbah":"01","volume":"1200","berat":"10000","ms_jns_limbah":{"id":1,"code":"01","nama":"TIpe Limbah Baru 01","status":true,"action":"I","date_action":"2024-08-20 15:56:06.598356+07"}}},{"id":84,"id_approval":63,"id_approval_request":39,"noted":null,"status":"10","action":"I","date_action":"2024-09-05 15:02:35.868405+07","approval_request":{"id":39,"id_unit":1,"id_rujukan_header":44,"id_rujukan_detail":43,"tipe_rujukan":"1","status":"10","date_create":"2024-08-23 14:25:08.734614+07","action":"U","date_action":"2024-09-05 14:13:53.99245+07","id_user":1,"id_jenis_limbah":2,"code_limbah":"02","volume":"1500","berat":"11000","ms_jns_limbah":{"id":2,"code":"02","nama":"TIpe Limbah Baru 02","status":true,"action":"I","date_action":"2024-08-20 15:56:20.340149+07"}}}]}}}');
      
      console.log('first', success);
      
      yield put(
        getTransferDetailSuccess(success),
      );
    } catch (err) {
      console.log(err);
      helper.errorToast("Terjadi kegagalan proses ambil data pastikan koneksi internet anda normal atau segera hubungi admin");
      yield put(getTransferDetailFail(err));
    }
  }

  // Individual exports for testing
  export default function* wasteTransferFormScreenSaga() {
    yield all([
      takeLatest(constants.SUBMIT_PELAPORAN, doSubmitPelaporan),
      takeLatest(constants.GET_TRANSFER_DETAIL, doGetTransferDetail),
    ]);
  }
  